export default "__VITE_ASSET__DrSrmLjL__"